import LocalStorage from "./localStorage.js";
import LocalStorageFactory from "./localStorageFactory.js";
import NamespacedLocalStorage from "./namespacedLocalStorage.js";

module.exports.LocalStorage = LocalStorage;
module.exports.LocalStorageFactory = LocalStorageFactory;
module.exports.NamespacedLocalStorage = NamespacedLocalStorage;
